import api from './api';

export interface KzmSettingsDto {
  project_id: string;
  ordering_party_name?: string | null;
  ordering_party_email?: string | null;
  inspector_build_name?: string | null;
  inspector_build_email?: string | null;
  inspector_sanitary_name?: string | null;
  inspector_sanitary_email?: string | null;
  inspector_electrical_name?: string | null;
  inspector_electrical_email?: string | null;
  inspector_telecom_name?: string | null;
  inspector_telecom_email?: string | null;
  cc_build?: string | null;
  cc_sanitary?: string | null;
  cc_electrical?: string | null;
  cc_telecom?: string | null;
  template_link?: string | null;
}

interface ApiResponse<T> {
  success: boolean;
  data?: T;
  message?: string;
}

export const getKzmSettings = async (projectId: string): Promise<KzmSettingsDto | null> => {
  const res = await api.get<ApiResponse<KzmSettingsDto>>(`/kzm-settings/${projectId}`);
  return res.data?.data || null;
};

export const upsertKzmSettings = async (projectId: string, settings: Omit<KzmSettingsDto, 'project_id'>): Promise<KzmSettingsDto> => {
  const res = await api.put<ApiResponse<KzmSettingsDto>>(`/kzm-settings/${projectId}`, settings);
  if (!res.data.success || !res.data.data) throw new Error(res.data.message || 'Nie udało się zapisać ustawień KZM');
  return res.data.data;
};

export default {
  getKzmSettings,
  upsertKzmSettings
};


